// Local translations
export const T = {
  en_GB: {
    download: "Download",
    showSummary: "Show summary",
    summaryAndText: "Summary and extracted text for this file.",
    loading: "Loading…",
    loadFailed: "Failed to load file detail",
    retry: "Retry",
    summary: "Summary",
    extractedText: "Extracted text",
    nothingAvailable: (status: string) =>
      `No summary or extracted text available (status: ${status}).`,
  },
  nb_NO: {
    download: "Last ned",
    showSummary: "Vis sammendrag",
    summaryAndText: "Sammendrag og uthentet tekst for denne filen.",
    loading: "Laster…",
    loadFailed: "Kunne ikke laste fildetaljer",
    retry: "Prøv igjen",
    summary: "Sammendrag",
    extractedText: "Uthentet tekst",
    nothingAvailable: (status: string) =>
      `Ingen sammendrag eller uthentet tekst tilgjengelig (status: ${status}).`,
  },
} as const;
